import { hasType, isBooleanControl, or, schemaMatches } from '@jsonforms/core';
export const isOneOfBoolean = or(isBooleanControl, schemaMatches((schema) => schema.hasOwnProperty('oneOf') && schema.oneOf.some((s) => hasType(s, 'boolean'))));
